import { render, staticRenderFns } from "./sales-broker.vue?vue&type=template&id=0a6fefed"
import script from "./sales-broker.vue?vue&type=script&lang=js"
export * from "./sales-broker.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports